import React from 'react';
import { Spinner} from 'react-bootstrap'  
import { useSelector } from "react-redux";

function LoginLayout(props) { 
      const {apiLoader} = useSelector(state => state);
    return ( 
          <> 
            {
                  (apiLoader) ?
                  <div className="loader-container">
                        <Spinner animation="border" variant="secondary" /> 
                  </div>
                  :
                  null
            }
            <div className="auth-body">
                  {props.children} 
            </div>
          </>
      );
}
  
export default LoginLayout;